import detail from './detail/routes';
import applied from './applied/routes';
import list from './list/routes';

export default [list, detail, applied];
